import { render, staticRenderFns } from "./linkdialog.vue?vue&type=template&id=1dd2339c&scoped=true"
import script from "./linkdialog.vue?vue&type=script&lang=js"
export * from "./linkdialog.vue?vue&type=script&lang=js"
import style0 from "./linkdialog.vue?vue&type=style&index=0&id=1dd2339c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd2339c",
  null
  
)

export default component.exports